<div class="flex flex-col gap-2 mb-4">
  <label class="text-sm font-medium text-gray-700">
    {{ props.label }} @if (props.required && !isReadonly) {
    <span class="text-red-500">*</span>
    }
  </label>

  @if (!isReadonly) {
  <!-- Edit Mode: Show file input and template download -->
  <div class="flex flex-col gap-2">
    <!-- Template Download -->
    @if (props['templateUrl']) {
    <div class="flex items-center gap-2">
      <a
        [href]="props['templateUrl']"
        download
        class="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 hover:underline"
      >
        <i class="fa-solid fa-download"></i>
        Download Template
      </a>
    </div>
    }

    <!-- File Input -->
    <div class="flex items-center gap-2">
      <input
        type="file"
        [accept]="props['accept'] || '.pdf,.doc,.docx'"
        (change)="onFileSelected($event)"
        class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
        #fileInput
      />
      @if (selectedFile) {
      <button mat-icon-button type="button" (click)="clearFile(fileInput)" title="Remove file">
        <mat-icon color="warn">delete</mat-icon>
      </button>
      }
    </div>

    @if (fileSizeError) {
    <div class="text-sm text-red-500">{{ fileSizeError }}</div>
    } @if (props.required && formControl.touched && !selectedFile && !formControl.value && !fileSizeError) {
    <div class="text-sm text-red-500">This field is required</div>
    }
  </div>
  } @else {
  <!-- Readonly Mode: Show download link for submitted file -->
  @if (formControl.value) {
  <div class="flex items-center gap-2">
    <button
      mat-raised-button
      color="primary"
      type="button"
      class="shrink-0"
      (click)="downloadSubmittedFile()"
      [disabled]="isDownloading()"
    >
      <span class="inline-flex items-center gap-2">
        @if (isDownloading()) {
        <mat-spinner diameter="16"></mat-spinner>
        } @else {
        <i class="fa-solid fa-download"></i>
        }
        <span>Download Submitted File</span>
      </span>
    </button>
    <span class="text-sm text-gray-500">{{ getFileName() }}</span>
  </div>
  } @else {
  <div class="text-sm text-gray-500 italic">No file submitted</div>
  } }
</div>
